import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'WATCHLIST_FIRST_TIME_USE_DIALOG';

// @ts-expect-error FIXME TS7006
export const watchlistFirstTimeUse = createAction(rootUiActions.createDialog.toString(), (isDashBoard) =>
  rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    props: ImmutableMap({
      isDashBoard,
    }),
  }),
);
